import { DbMongoBaseInfos } from "./db-mongo-base-infos";

export interface ColumnSetDependencyInfos {
  fieldId: number | null;
  activeForValues: string[] | null;
  values: string[] | null;
}
export class DbIngestConfigColumnSetInfos extends DbMongoBaseInfos {
  daletDataFieldTagName: string | null = null;
  dependancyDaletDataFieldTagName: string | null = null;
  isMandatory: boolean | null = null;
  isHidden: boolean | null = null;
  isToFillDuringIngest: boolean | null = null;
  isEditable: boolean | null = null;
  order: number | null = 0;
  fieldId: number | null = 0;
  platformId: number | null = 0;
  label: string | null = null;
  dependencies: ColumnSetDependencyInfos[] | null = null;

  constructor(init?: Partial<DbIngestConfigColumnSetInfos>) {
    super();
    Object.assign(this, init);
  }
}
